<template>
    <div v-if="visible">
        <div class="wrapper">
            <span class="block-head">Summer edition</span><span class="block-desc">Provide your opinion of Luxoft and get access to exclusive summer gifts</span>
        </div>
        <div class="line-wrap">
            <div class="wrapper">
                <div class="coll">
                    <div class="gift-item">
                        <div class="img">
                            <div class="img-content progressive-image" style="max-width: 512px;"><span>
                                    <!---->
                                    <div class="progressive-image-wrapper" style="padding-bottom: 100%;"><img
                                            class="progressive-image-main"
                                            src="https://sailplays3.cdnvideo.ru/media/assets/assetfile/e27600755274571ea280cfd9144ae9fd.jpg"
                                            style="">
                                        <!---->
                                    </div>
                                </span></div>
                        </div>
                        <div class="info"><span class="name">Towel</span>
                            <!----><span class="ball">70 points</span></div>
                        <div class="gift-hover">
                            <div class="center"><span class="name">Towel</span><span class="desc">Provide your opinion of Luxoft and get access to exclusive summer gifts</span></div>
                        </div>
                        <!---->
                    </div>
                    <div class="gift-item">
                        <div class="img">
                            <div class="img-content progressive-image" style="max-width: 512px;"><span>
                                    <!---->
                                    <div class="progressive-image-wrapper" style="padding-bottom: 100%;"><img
                                            class="progressive-image-main"
                                            src="https://sailplays3.cdnvideo.ru/media/assets/assetfile/71a7c1f71efa10bfd8ed87a6b95585f1.jpg"
                                            style="">
                                        <!---->
                                    </div>
                                </span></div>
                        </div>
                        <div class="info"><span class="name">Chair</span>
                            <!----><span class="ball">150 points</span></div>
                        <div class="gift-hover">
                            <div class="center"><span class="name">Chair</span><span class="desc">Provide your opinion of Luxoft and get access to exclusive summer gifts</span></div>
                        </div>
                        <!---->
                    </div>
                    <div class="gift-item">
                        <div class="img">
                            <div class="img-content progressive-image" style="max-width: 512px;"><span>
                                    <!---->
                                    <div class="progressive-image-wrapper" style="padding-bottom: 100%;"><img
                                            class="progressive-image-main"
                                            src="https://sailplays3.cdnvideo.ru/media/assets/assetfile/9ff851d76c35295e1b2ecd0f4bacc9c2.jpg"
                                            style="">
                                        <!---->
                                    </div>
                                </span></div>
                        </div>
                        <div class="info"><span class="name">Cooler</span>
                            <!----><span class="ball">200 points</span></div>
                        <div class="gift-hover">
                            <div class="center"><span class="name">Cooler</span><span class="desc">Provide your opinion of Luxoft and get access to exclusive summer gifts</span></div>
                        </div>
                        <!---->
                    </div>
                    <div data-v-10fc509e="" class="gift-item">
                        <div data-v-10fc509e="" class="img">
                        <div
                            data-v-10fc509e=""
                            class="img-content progressive-image"
                            style="max-width: 512px"
                        >
                            <span data-v-10fc509e=""
                            ><div
                                data-v-10fc509e=""
                                class="progressive-image-wrapper"
                                style="padding-bottom: 100%"
                            >
                                <img
                                data-v-10fc509e=""
                                src="https://sailplays3.cdnvideo.ru/media/assets/assetfile/7cdee26b6211e9ef8b230331fac26d47.jpg"
                                class="progressive-image-main"
                                /></div
                            ></span>
                        </div>
                        </div>
                        <div data-v-10fc509e="" class="info">
                        <span data-v-10fc509e="" class="name">Stand up paddle board</span
                        ><span data-v-10fc509e="" class="ball">450 points</span>
                        </div>
                        <div data-v-10fc509e="" class="gift-hover">
                        <div data-v-10fc509e="" class="center">
                            <span data-v-10fc509e="" class="name"
                            >Stand up paddle board</span
                            >
                            <div data-v-10fc509e="" class="desc">
                            Take your Zen exercise to the water with our reliable, sleek
                            SUP board. Please note: the design may vary by location
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'


export default {
  name: 'AppGiftsBanner',
  computed: {
    visible () {
        return this.currentTags && !this.currentTags.find(tag => tag.tag === 'Summer season review') && !this.isItPlatformaUser
    },
    ...mapGetters(['currentTags', 'isItPlatformaUser'])
  }
}
</script>

<style scoped lang='scss'>
.img, .info .name, .info .ball {
    opacity: 0.5;
}
</style>